<template>
  <card>
    <list
      v-if="$store.state.user.sections['users']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  created() {
    if (this.$store.state.user.is_system) {
      this.columns.push({
        key: "code",
        title: "CODE",
        titleKey: "id",
        checkbox: false,
        control: false,
        align: "left",
        timer: false,
        detail: false,
      });
    }
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "season",
      fields: [
        {
          type: "field",
          key: "name",
          labelKey: "full_name",
          label: "Полное имя",
        },

        {
          type: "mask",
          mask: "+998#########",
          key: "phone",
          labelKey: "phone",
          label: "Номер телефона",
          default: "+998",
        },
        {
          type: "field",
          key: "email",
          labelKey: "email",
          label: "Email",
        },
        {
          type: "field",
          key: "password",
          labelKey: "password",
          label: "Пароль",
        },

        {
          label: "Роль",
          key: "role",
          labelKey: "role",
          type: "select",
          modal: "role",
          selectKey: "name",
        },
        {
          label: "Торговые точки",
          key: "shops",
          labelKey: "shops",
          type: "selects",
          modal: "shop",
          selectKey: "name",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_user",
      itemLink: "users",
      setLink: "users",
      columns: [
        {
          key: "id",
          title: "id",
          titleKey: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "name",
          titleKey: "full_name",
          title: "Полное имя",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "email",
          titleKey: "email",
          title: "Email",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "phone",
          titleKey: "phone",
          title: "Номер телефона",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "role",
          titleKey: "role",
          object: "name",
          title: "Роль сотрудника",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          //remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
